import { render, staticRenderFns } from "./DynamicObjectDetail.vue?vue&type=template&id=d15d9f50"
import script from "./DynamicObjectDetail.vue?vue&type=script&lang=js"
export * from "./DynamicObjectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports